/**
 * Cities as Inverted Watersheds - Main Application Entry Point
 */
import 'ol/ol.css';
import { AppState } from './js/controllers/appState.js';
import { MapController } from './js/controllers/mapController.js';
import { UIController } from './js/controllers/uiController.js';
import { createTimelineMarkers } from './js/utils/sigmaUtils.js';

/**
 * Initialize the application when the DOM is ready
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize app state
  AppState.initialize();
  
  // Create the map controller
  const mapController = new MapController();
  
  // Create the UI controller with map controller reference
  const uiController = new UIController(mapController);
  
  // Make controllers globally available
  window.mapController = mapController;
  window.uiController = uiController;
  
  // Apply initial filter values
  mapController.updateAllLayersOpacity();
  
  // Create markers for timeline
  createTimelineMarkers();
  
  // Set up the share button
  setupShareButton();
  
  // Apply state from URL parameters (if any)
  applyStateFromUrl();
});

/**
 * Set up the share button functionality
 */
function setupShareButton() {
  const shareButton = document.getElementById('share-button');
  
  if (shareButton) {
    shareButton.addEventListener('click', () => {
      // Generate shareable URL
      const shareUrl = AppState.createShareableUrl();
      
      // Create a temporary input element to copy the URL
      const tempInput = document.createElement('input');
      tempInput.value = shareUrl;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      
      // Temporarily change button text to indicate success
      const originalText = shareButton.innerText;
      shareButton.innerText = '✓';
      shareButton.title = 'Link copied to clipboard!';
      
      // Revert button text after a short delay
      setTimeout(() => {
        shareButton.innerText = originalText;
        shareButton.title = 'Share current view';
      }, 2000);
    });
  }
}

/**
 * Apply state from URL parameters
 */
function applyStateFromUrl() {
  // Get URL parameters
  const params = new URLSearchParams(window.location.search);
  
  // Only proceed if there are parameters
  if (params.toString()) {
    // Apply state from params
    AppState.applyStateFromUrl(params);
  }
}